module.exports = __webpack_public_path__ + "img/171.f2345803.jpg";